import { render, staticRenderFns } from "./FundingClaimsIndex.vue?vue&type=template&id=5dbbf904&"
import script from "./FundingClaimsIndex.vue?vue&type=script&lang=js&"
export * from "./FundingClaimsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports